import { SortingRule } from 'react-table';
import { atom, selector } from 'recoil';

import { GetIncomingConsultationsRequest } from 'api';
import { FilterOption, IncomingConsultation } from 'types';

export const incomingConsultationsTrafficMonitorFiltersState = atom<FilterOption[]>({
  key: 'incomingConsultationsTrafficMonitorFilters',
  default: [],
});

export const incomingConsultationsByReferenceNumberState = atom<string>({
  key: 'incomingConsultationsByReferenceNumber',
  default: '',
});

export const incomingConsultationsTrafficMonitorOrderByColumnState = atom<string | undefined>({
  key: 'incomingConsultationsTrafficMonitorOrderByColumn',
  default: undefined,
});

export const incomingConsultationsTrafficMonitorOrderByDescendingState = atom<boolean>({
  key: 'incomingConsultationsTrafficMonitorOrderByDescending',
  default: false,
});

export const incomingConsultationsTrafficMonitorPageSizeState = atom<number>({
  key: 'incomingConsultationsTrafficMonitorPageSize',
  default: 10,
});

export const incomingConsultationsTrafficMonitorPageNumberState = atom<number>({
  key: 'incomingConsultationsTrafficMonitorPageNumber',
  default: 1,
});

export const incomingConsultationsTrafficMonitorSortByState = selector<
  SortingRule<IncomingConsultation>[]
>({
  key: 'incomingConsultationsTrafficMonitorSortBy',
  get: ({ get }) => {
    const orderByColumn = get(incomingConsultationsTrafficMonitorOrderByColumnState);
    const orderByDescending = get(incomingConsultationsTrafficMonitorOrderByDescendingState);
    return orderByColumn ? [{ id: orderByColumn, desc: orderByDescending }] : [];
  },
});

export const incomingConsultationsTrafficMonitorRequestState =
  selector<GetIncomingConsultationsRequest>({
    key: 'incomingConsultationsRequest',
    get: ({ get }) => {
      const sortByDesc = get(incomingConsultationsTrafficMonitorOrderByDescendingState);
      const sortByColumn = get(incomingConsultationsTrafficMonitorOrderByColumnState);
      const statusValue = get(incomingConsultationsTrafficMonitorFiltersState).filter(
        (x) => x.name === 'status'
      )[0]?.selectedItems[0]?.value;
      const applicationReferenceNumberValue = get(incomingConsultationsByReferenceNumberState);

      const request = {
        pageNumber: get(incomingConsultationsTrafficMonitorPageNumberState),
        pageSize: get(incomingConsultationsTrafficMonitorPageSizeState),
        ...(sortByColumn && {
          orderByColumn: sortByColumn,
          sortBy: sortByDesc ? 'Descending' : 'Ascending',
        }),
        ...(statusValue && {
          status: statusValue ?? '',
        }),
        ...(applicationReferenceNumberValue && {
          planningApplicationReferenceNo: applicationReferenceNumberValue,
        }),
      } as unknown as GetIncomingConsultationsRequest;

      get(incomingConsultationsTrafficMonitorFiltersState).forEach((filter) => {
        request[filter.name] = filter.selectedItems.map((selected) => selected.value);
      });

      return request;
    },
  });
